import { useState, useEffect } from 'react'
import styled from '@emotion/styled'
import { csv } from 'd3-fetch'
import { Theme } from '../../styles/settings/theme'
import { MediaQueries as Mq } from '../../styles/settings/theme'

import { Flex, Content } from '../atoms/Basics'
import ChartTitle from '../atoms/ChartTitle'
import ChartContainer from '../atoms/ChartContainer'
import PercentTickAxis from '../atoms/PercentTickAxis'
import LegendColors from '../atoms/LegendColors'
import Subtitle from '../atoms/Subtitle'
import Note from '../atoms/Note'

const RowFlex = styled(Flex)`
  align-items: center;
  margin: 0 1rem 0.5rem;
`
const Label = styled.div`
  color: ${(props) => props.theme.colors.gray};
  margin: 0 1rem 0 0;
  //min-width: 16rem;
  width: 17rem;
  font-size: ${(props) => props.theme.fontSizes[0]};
  font-weight: 600;
  text-align: right;
  ${Mq.md} {
    font-size: 12px;
    width: 11rem;
  }
  ${Mq.sm} {
    font-size: 11px;
    width: 9rem;
  }
  ${Mq.xs} {
    font-size: 10px;
    width: 7.5rem;
  }
`
const BaseBar = styled.div`
  flex: 1;
  height: 2rem;
  background-color: ${(props) => props.theme.colors.gray1};
  position: relative;
`
const RankBar = styled.div`
  position: absolute;
  top: 0;
  left: ${(props) => props.left}%;
  background-color: ${(props) => props.color};
  height: 2rem;
  width: ${(props) => props.width}%;
`

const TickContainer = styled.div`
  flex: 1;
  position: relative;
  height: 6rem;
`

const Constraints = ({ note }) => {
  const $ = window.WILDLABS_VARS
  const [userData, setUserData] = useState(null)
  const [devData, setDevData] = useState(null)

  useEffect(() => {
    csv('./data/userConstraints.csv').then((data) => {
      setUserData(data)
    })
    csv('./data/developerConstraints.csv').then((data) => {
      setDevData(data)
    })
  }, [])

  const colors = [
    Theme.colors.darkBlue,
    Theme.colors.blue,
    Theme.colors.lightBlue,
    Theme.colors.gray2,
    Theme.colors.gray1
  ]

  const allBars = [
    $.constraints_columns.First,
    $.constraints_columns.Second,
    $.constraints_columns.Third,
    $.constraints_columns.Fourth
    //columns.Fifth
  ]

  //gets array of column names to sum
  const bars = (i) => {
    return allBars.slice(0, i)
  }

  //sums all previous bars to find starting point of current bar
  const calcValue = (i, row) => {
    const colsToSum = bars(i)
    return colsToSum.reduce((acc, curr) => {
      return acc + +row[curr]
    }, 0)
  }

  const userSorted = userData?.sort((a, b) => {
    return a[$.constraints_columns.Sixth] - b[$.constraints_columns.Sixth]
  })

  const devSorted = devData?.sort((a, b) => {
    return a[$.constraints_columns.Sixth] - b[$.constraints_columns.Sixth]
  })

  return (
    <ChartContainer>
      <ChartTitle text={$.constraints_titles.chartTitle} />
      <Content flexDirection="column">
        <RowFlex justifyContent="space-between">
          <LegendColors
            colors={colors}
            columns={userData?.columns.slice(1, 6).reverse()}
          />
        </RowFlex>
        {/* user chart */}
        <RowFlex>
          <Label></Label>
          <TickContainer>
            <Flex justifyContent="center">
              <Subtitle
                text={$.constraints_titles.subtitleA}
                size={Theme.fontSizes[2]}
                color={Theme.colors.gray}
              ></Subtitle>
            </Flex>
            <PercentTickAxis />
          </TickContainer>
        </RowFlex>
        {userSorted?.map((row, i) => (
          <RowFlex key={row.categories}>
            <Label>{row.categories}</Label>
            <BaseBar>
              {colors.map((color, i) => (
                <RankBar
                  key={`${color} + i`}
                  color={color}
                  left={calcValue(i, row) * 100}
                  width={allBars[i] ? row[allBars[i]] * 100 : 0}
                ></RankBar>
              ))}
            </BaseBar>
          </RowFlex>
        ))}
        {/* dev chart */}
        <RowFlex>
          <Label></Label>
          <TickContainer>
            <Flex justifyContent="center">
              <Subtitle
                text={$.constraints_titles.subtitleB}
                size={Theme.fontSizes[2]}
                color={Theme.colors.gray}
              ></Subtitle>
            </Flex>
            <PercentTickAxis />
          </TickContainer>
        </RowFlex>
        {devSorted?.map((row, i) => (
          <RowFlex key={`${row.categories} + i`}>
            <Label>{row.categories}</Label>
            <BaseBar>
              {colors.map((color, i) => (
                <RankBar
                  key={`${color} + 'a'`}
                  color={color}
                  left={calcValue(i, row) * 100}
                  width={allBars[i] ? row[allBars[i]] * 100 : 0}
                ></RankBar>
              ))}
            </BaseBar>
          </RowFlex>
        ))}
      </Content>
      <Note note={note} />
    </ChartContainer>
  )
}

export default Constraints
